import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
function Avatar(_ref) {
  let {
    text,
    className = {}
  } = _ref;
  const initials = text.substring(0, 2).toUpperCase();
  return /*#__PURE__*/_jsx("div", {
    className: clsx('avatar bg-blue text-size-400 text-center text-inverse flex-shrink-0', className)
  }, void 0, initials);
}
export default Avatar;